import { render, staticRenderFns } from "./RecyclePercentageChart.vue?vue&type=template&id=4565c802&scoped=true"
import script from "./RecyclePercentageChart.vue?vue&type=script&lang=js"
export * from "./RecyclePercentageChart.vue?vue&type=script&lang=js"
import style0 from "./RecyclePercentageChart.vue?vue&type=style&index=0&id=4565c802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565c802",
  null
  
)

export default component.exports